import React, { ReactNode, CSSProperties } from "react";
import { Theme } from "@emotion/react";

const getTooltipContainerStyle = (
  theme: Theme,
  withShadow: boolean
): CSSProperties => ({
  display: "flex",
  flexDirection: "column",
  position: "absolute",
  borderRadius: "10px",
  backgroundColor: theme.palette.background.tooltipPrimary,
  border: `1px solid ${theme.palette.border.tooltipPrimary}`,
  boxShadow: withShadow ? theme.shadows[1] : "none",
  padding: "14px 18px 13px 20px",
  alignSelf: "flex-start",
  minWidth: "247px",
});

const getFirstRowStyle = (hasChildren: boolean): CSSProperties => ({
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
  marginBottom: hasChildren ? "12px" : "0",
});

const childRowStyles: CSSProperties = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gridColumnGap: "16px",
  gridRowGap: "12px",
  margin: "4px 0",
  minWidth: "fit-content",
};

interface Props {
  firstRow?: ReactNode;
  withShadow?: boolean;
  children: ReactNode;
  theme: Theme;
}

export const CustomTooltipContainer = ({
  firstRow,
  children,
  theme,
  withShadow = false,
}: Props) => {
  const count = React.Children.count(children);

  return (
    <div
      id="custom-tooltip-container"
      style={getTooltipContainerStyle(theme, withShadow)}
    >
      {firstRow && (
        <div style={getFirstRowStyle(count > 0)}>
          <div style={{ marginRight: "16px" }}>{firstRow}</div>
        </div>
      )}
      <div style={childRowStyles}>{children}</div>
    </div>
  );
};
